import { PAGES_WITH_NOW_GLOBAL_BAR } from 'shared/consts'
import { NOW_PDP_SERP_GB_FUNCTIONALITY } from 'shared/experiments/consts'
import { type Experiment } from 'types/shopConfig'
import buildClientAPI from 'views/providers/clientAPI'

const threeMinutesInMs = 3 * 60 * 1000
let asid: string | null = null
let expirationDate: Date | null = null

const fetchAsid = async () => {
  if (expirationDate && new Date().getTime() < expirationDate.getTime()) {
    return
  }

  try {
    asid = (await buildClientAPI().addressSuggestService.register()).data
      .success.asid

    expirationDate = new Date(new Date().getTime() + threeMinutesInMs)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Cannot register to AddressService: ', e)
  }
}

const fetchCityByZipCode: (zip: string) => Promise<string> = async (
  zip: string
) => {
  if (!zip) {
    return ''
  }
  try {
    await fetchAsid()
    return (await buildClientAPI().addressSuggestService.fetchCity(asid, zip))
      ?.data?.cities[0]
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Cannot fetch cities from AddressService: ', e)
    return ''
  }
}

const shouldDisplayNowGlobalBar: (
  pageType: string,
  experiments: Experiment[]
) => boolean = (pageType, experiments) =>
  experiments?.some(
    ({ name, isEnabled }) => name === NOW_PDP_SERP_GB_FUNCTIONALITY && isEnabled
  ) && PAGES_WITH_NOW_GLOBAL_BAR.some(page => page === pageType)

export { fetchCityByZipCode, shouldDisplayNowGlobalBar }
